<template>
  <div style="background-color: #f5f7f9; width: 102.47%; margin: -10px -20px;">
    <div style="display: flex; height: 30px; margin: 10px -20px 20px 10px;">
      <div style="width: 3%; height: 30px; margin-top: 12px; margin-right: -20px;">
        <img src="../../assets/common/image/trumpet.png" width="24" />
      </div>
      <marquee loop="-1" height="30px" bgcolor="#fef0f0" hspace="10" vspace="10"
        style="line-height: 30px; color: #f56c6c; font-size: 14px; width: 96%; margin-right: -40px;">
        注意：每周四/周五17:00-21:30为系统维护时间，将不定时重启服务，会出现5-10秒的卡顿，请尽量避免在该时段使用系统！
      </marquee>
    </div>
    <div class="content">
      <div class="left">
        <!-- 代办事项 -->
        <div class="left_top">
          <div
            style="height: 30px; line-height: 30px; margin-left: 20px; text-align: left; font-weight: bold; font-size: 14px;">
            代办事项</div>
          <div style="width: 100%; height: 1px; background-color: #ebeef5;"></div>
          <div class="footer" style="padding:0px 20px">
            <div class="top_contant" @click="returnGoods()" style="flex: 1;">
              <div class="image">
                <img style="margin-left: 4px; width: 45px; height: 45px; margin-top: 13px;"
                  src="../../assets/common/image/orderCheck.png" />
              </div>
              <div class="top_foot">
                <div>待审核退货</div>
                <div style="font-size: 18px; font-weight: bold;">{{ returnGoodsCount }}</div>
              </div>
            </div>
            <div class="top_contant" @click="inStorage()" style="flex: 1;">
              <div class="image">
                <img style="margin-left: 2px; width: 45px; height: 45px; margin-top: 12px;"
                  src="../../assets/common/image/orderReturn.png" />
              </div>
              <div class="top_foot">
                <div>待入库采购单</div>
                <div style="font-size:18px;font-weight: bold">{{ inStorageCount }}</div>
              </div>
            </div>
            <div class="top_contant" @click="checkAccept()" v-if="showCheckAccept">
              <div class="image">
                <img style="margin-left: 1px; width: 50px; height: 50px; margin-top: 10px;"
                  src="../../assets/common/image/orderLate.png" />
              </div>
              <div class="top_foot">
                <div>待出库销售单</div>
                <div style="font-size:18px;font-weight: bold">{{ checkAcceptCount }}</div>
              </div>
            </div>
          </div>
        </div>
        <div class="left_bottom">
          <div
            style="height: 30px; line-height: 30px; margin-left: 20px; text-align: left; font-weight: bold; font-size: 14px;">
            今日订单情况
          </div>
          <div style="width:100%;height:1px;background-color:#ebeef5"></div>
          <div class="footer" style="padding:17px 20px">
            <div class="two_contant">
              <div class="top_contant_two" style="background-color:#E6A23C">
                <div class="image">
                  <img style="width:80px;height:80px" src="../../assets/common/image/noStamp.png" />
                </div>
                <div class="top_foot">
                  <div>未处理订单</div>
                  <div><span style="font-size:18px;font-weight: bold">{{ toNotSeeCount }}</span> 张</div>
                  <div>总金额：{{ Number(toNotSeeFee).toFixed(2) }}</div>
                </div>
              </div>
              <div class="two_bottom" style="background-color:#E6A23C;opacity:0.9;color:#fff" @click="toNotSee()">
                <div>数据详情</div>
                <div><i class="el-icon-d-arrow-right"></i></div>
              </div>
            </div>
            <div class="two_contant">
              <div class="top_contant_two" style="background-color:#409EFF">
                <div class="image">
                  <img style="width:80px;height:80px" src="../../assets/common/image/ordering.png" />
                </div>
                <div class="top_foot">
                  <div>未验收/确认订单</div>
                  <div><span style="font-size:18px;font-weight: bold">{{ toNotAcceptCount }}</span> 张</div>
                  <div>项目订购金额：{{ Number(toNotAcceptFee).toFixed(2) }}</div>
                </div>
              </div>
              <div class="two_bottom" style="background-color:#409EFF;opacity:0.9;color:#fff" @click="toNotAccept()">
                <div>数据详情</div>
                <div><i class="el-icon-d-arrow-right"></i></div>
              </div>
            </div>
            <div class="two_contant">
              <div class="top_contant_two" style="background-color:#67C23A">
                <div class="image">
                  <img style="width:80px;height:80px" src="../../assets/common/image/order_finish.png" />
                </div>
                <div class="top_foot">
                  <div>已验收订单</div>
                  <div><span style="font-size:18px;font-weight: bold">{{ toAcceptedCount }}</span> 张</div>
                  <div>项目订购金额：{{ Number(toAcceptedFee).toFixed(2) }}</div>
                </div>
              </div>
              <div class="two_bottom" style="background-color:#67C23A;opacity:0.9;color:#fff" @click="toAccepted()">
                <div>数据详情</div>
                <div><i class="el-icon-d-arrow-right"></i></div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="right">
        <div class="right_top">
          <div
            style="height:30px;line-height:30px;margin-left:20px;text-align: left;font-weight: bold;font-size: 14px;">
            系统通知</div>
          <div style="width:100%;height:1px;background-color:#ebeef5"></div>

          <div style="width:100%;"></div>
          <div style="width:100%">
            <el-alert title="注意：为保障各位用户的账号安全，于2021年7月17日起，对于仍使用原始密码的用户，系统将强制您修改密码后才可登入系统。密码一经修改无法重置，请大家务必记住修改后密码！！"
              type="error" :closable="false" style="margin-top: 30px;width: 92%;margin-left: 4%;text-align: left;">
            </el-alert>
          </div>
        </div>

      </div>
    </div>
    <!-- 下半内容 -->
    <div class="content" style="margin-top:20px">
      <div class="left" style="display:flex;">
        <div class="left_left">
          <div
            style="height:30px;line-height:30px;padding:0 20px;display: flex;justify-content: space-between;font-size:14px">
            <span style="font-weight: bold">资质上传提醒</span>
            <el-button type="text" style="color: #3399ff; padding: 0;"
              @click="checkQualificationUpload">查看更多>></el-button>
          </div>
          <div style="width:100%;height:1px;background-color:#ebeef5"></div>
          <div>
            <div style="margin-top:10px">资质上传进度</div>
            <div style="margin-top:10px">
              <el-progress type="circle" :percentage="计算上传进度"></el-progress>
            </div>
            <div class="upload">
              <span style="width:30px;height:20px;background-color:rgb(51, 153, 255);"></span>
              <span style="margin-left:10px">已上传</span>
              <span style="width:30px;height:20px;background-color:#ccc;margin-left:25%"></span>
              <span style="margin-left:10px">未上传</span>
            </div>
            <div class="uploadFooter" style="margin-top:0px">
              <span>今日供应产品个数</span>
              <span>{{ 资质上传数据.total_product_count }}</span>
            </div>
            <div class="uploadFooter">
              <span>已上传资质产品个数</span>
              <span>{{ 资质上传数据.upload_num }}</span>
            </div>
            <div class="uploadFooter">
              <span>未上传资质产品个数</span>
              <span>{{ 资质上传数据.not_upload_num }}</span>
            </div>
          </div>
        </div>
        <div class="left_right">
          <div
            style="height:30px;line-height:30px;padding:0 20px;display: flex;justify-content: space-between;font-size:14px">
            <span style="font-weight: bold">供应商资质预警</span>
            <span style="color:#ccc" @click="checkSupplier()">查看更多>></span>
          </div>
          <div style="width:100%;height:1px;background-color:#ebeef5"></div>
          <div class="footer" style="padding:0px 0px 0px 20px">
            <el-row style="width: 100%;">
              <el-col>
                <el-table :data="checkSupplierArry" style="width: 100%;"
                  :cell-style="{ 'text-align': 'left', 'border': '1px solid #fff' }" height="320">
                  <el-table-column prop="SUPPLIER_NAME" label="供应商名称" min-width="80"></el-table-column>
                  <el-table-column prop="NAME" label="资质" min-width="80"></el-table-column>
                  <el-table-column prop="EXPIRE_DATE" label="过期日期" min-width="80"></el-table-column>
                  <!-- <el-table-column min-width="80" >
                    <template slot-scope="scope">
                      <el-tag  type='danger'> 已&nbsp; 过&nbsp;期</el-tag>
                    </template>
</el-table-column> -->
                </el-table>
              </el-col>
            </el-row>
          </div>
        </div>
      </div>
      <div class="right">
        <div class="right_top">
          <div
            style="height:30px;line-height:30px;padding:0 20px;display: flex;justify-content: space-between;font-size:14px">
            <span style="font-weight: bold">库存临期产品</span>
            <span style="color:#ccc" @click="checkMoreStorge()">查看更多>></span>
          </div>
          <div style="width:100%;height:1px;background-color:#ebeef5"></div>
          <div class="footer" style="padding:0px 0px 0px 20px">
            <el-row style="width: 100%;">
              <el-col>
                <el-table :data="StorgeDataArry" style="width: 100%;"
                  :cell-style="{ 'text-align': 'left', 'border': '1px solid #fff' }" height="320">
                  <el-table-column prop="PRODUCT_NAME" label="品名" min-width="120"></el-table-column>
                  <el-table-column prop="TYPE_UNIT" label="单位" min-width="60"></el-table-column>
                  <!-- <el-table-column prop="PRODUCT_PRICE" label="单价" min-width="60"></el-table-column> -->
                  <el-table-column prop="PRODUCT_COUNT" label="库存数量" min-width="60"></el-table-column>
                  <!-- <el-table-column prop="PRODUCT_WORTH" label="库存金额" min-width="60"></el-table-column> -->
                  <el-table-column prop="PRODUCTION_DATE" label="生产日期" min-width="75"></el-table-column>
                  <el-table-column label="保质期" min-width="60">
                    <template slot-scope="scope">
                      <span>{{ scope.row.QGP + QGP_TIME_TYPE[scope.row.QGP_TIME_TYPE] }}</span>
                    </template>
                  </el-table-column>
                  <!-- <el-table-column prop="EXPIRATION_DAY" label="保质期(天)" min-width="60"></el-table-column> -->
                </el-table>
              </el-col>
            </el-row>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import http from '@/assets/common/http';
import util from '@/assets/common/util';
import date from '@/assets/common/date';

export default {
  data () {
    return {
      资质上传数据: { total_product_count: 0 },
      returnGoodsCount: 0,
      inStorageCount: 0,
      checkAcceptCount: 0,
      checkAcceptCountOne: 0,
      toNotSeeCountOne: 0,
      toNotSeeCount: 0,
      toNotSeeFeeOne: 0,
      toNotSeeFee: 0,

      toNotAcceptCount: 0,
      toNotAcceptFee: 0,
      toAcceptedCount: 0,
      toAcceptedFee: 0,
      StorgeDataArry: [],
      checkSupplierArry: [],
      QGP_TIME_TYPE: ['', '年', '季', '个月', '天', '小时'],
    };
  },
  computed: {
    计算上传进度 () {
      if (this.资质上传数据.total_product_count == 0) {
        return 0;
      }
      return parseFloat(((this.资质上传数据.upload_num / this.资质上传数据.total_product_count) * 100).toFixed(2));
    },
    showCheckAccept () {
      return sessionStorage.getItem('asyncRouterMap').includes('"MENU_CODE":"10501"');
    },
  },
  created () {
    // 待审核退货
    this.returnGoodsData();
    this.inStorageData();
    this.checkAcceptDataOne();
    this.toNotSeeDataOne();
    this.toAcceptedData();
    this.checkMoreStorgeData();
    this.getSupplierQualification();
    this.拉取资质上传比例();
  },
  mounted () { },
  methods: {
    拉取资质上传比例 () {
      const params = {
        SERVICE_ID: '10035',
        OTYPE: 42,
        SUPPLIER_ID: Number(sessionStorage.getItem('tcId')),
        SEND_DAY: date(new Date(), '%F'),
      };
      http.post(params).then((res) => {
        this.资质上传数据 = res[0];
      }).catch((error) => {

      });
    },
    checkQualificationUpload () { this.$router.push({ path: '/qualificatManage' }); },
    // 待审核退货
    returnGoods () {
      this.$router.push({ path: '/returnAudit/' });
    },
    // 入库采购单
    inStorage () {
      this.$router.push({ path: '/stockEnter/' });
    },
    // 待出库销售单
    checkAccept () {
      this.$router.push({ path: '/stockOut/' });
    },
    // 未处理订单
    toNotSee () {
      this.$router.push({ path: '/NewOrderList/' });
    },
    // 未验收/确认订单
    toNotAccept () {
      this.$router.push({ path: '/OrderConfirmList/' });
    },
    // 已验收订单
    toAccepted () {
      this.$router.push({ path: '/s_HistoryOrderList/' });
    },
    // 数据拉取
    returnGoodsData () {
      const params = {
        SERVICE_ID: '10028',
        OTYPE: 10,
        SUPPLIER_ID: Number(sessionStorage.getItem('tcId')),
      };
      http.post(params).then((result) => {
        if (result) {
          this.returnGoodsCount = result.length;
        }
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
      });
    },
    inStorageData () {
      const params = {
        SERVICE_ID: '10031',
        OTYPE: 14,
        GYS_ID: Number(sessionStorage.getItem('tcId')),
      };
      http.post(params).then((result) => {
        if (result[0].list.length > 0) {
          this.inStorageCount = result[0].TOTAL_COUNT;
        }
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
      });
    },
    checkAcceptDataOne () {
      const params = {
        SERVICE_ID: '10031',
        OTYPE: 17,
        GYS_ID: Number(sessionStorage.getItem('tcId')),
        PAGEINDEX: 0,
        PAGESIZE: 1,
      };
      http.post(params).then((result) => {
        if (result[0]) {
          this.checkAcceptCountOne = result[0].TOTAL;
        }
        this.checkAcceptDataTwo();
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
      });
    },
    checkAcceptDataTwo () {
      const params = {
        SERVICE_ID: '10031',
        OTYPE: 17,
        GYS_ID: Number(sessionStorage.getItem('tcId')),
        PAGEINDEX: 0,
        PAGESIZE: 1,
        IS_SUPPLIER_CLIENT: 1,
      };
      http.post(params).then((result) => {
        if (result.length > 0) {
          this.checkAcceptCount = result[0].TOTAL + this.checkAcceptCountOne;
        } else {
          this.checkAcceptCount = this.checkAcceptCountOne;
        }
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
      });
    },
    // 未处理订单
    toNotSeeDataOne () {
      const params = {
        SERVICE_ID: '10009',
        OTYPE: 1,
        SUPPLIER_ID: Number(sessionStorage.getItem('tcId')),
        GET_COUNT: 1,
      };
      http.post(params).then((result) => {
        if (result.length > 0) {
          this.toNotSeeCountOne = result[0].TOTAL_COUNT;
          this.toNotSeeFeeOne += Number(result[0].FEE);
        }
        this.toNotSeeData();
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
      });
    },
    toNotSeeData () {
      const params = {
        SERVICE_ID: '10003',
        OTYPE: 7,
        GYS_ID: Number(sessionStorage.getItem('tcId')),
        IS_SUPPLIER_CLIENT: 1,
        GET_COUNT: 1,
      };
      http.post(params).then((result) => {
        if (result.length > 0) {
          this.toNotSeeCount = result[0].TOTAL_COUNT + this.toNotSeeCountOne;
          this.toNotSeeFee = this.toNotSeeFeeOne + Number(result[0].FEE);
        } else {
          this.toNotSeeCount = this.toNotSeeCountOne;
          this.toNotSeeFee = this.toNotSeeFeeOne;
        }
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
      });
    },

    // 已验收订单
    toAcceptedData () {
      const params = {
        SERVICE_ID: '10034',
        OTYPE: 1,
        GYS_ID: Number(sessionStorage.getItem('tcId')),
        START_DAY: util.getNowDate(),
        END_DAY: util.getNowDate(),
        GET_COUNT: 1,
      };
      http.post(params).then((result) => {
        if (result[0]) {
          this.toAcceptedCount = result[0].TOTAL_COUNT;
          this.toAcceptedFee = Number(result[0].FEE);
        }
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
      });
    },

    getDaysBetween (startDate, enDate) {
      const sDate = Date.parse(startDate);
      const eDate = Date.parse(enDate);
      if (sDate > eDate) return 0; // 开始日期大于结束日期，返回0
      if (sDate === eDate) return 1; // 如果日期相同 返回一天
      return (eDate - sDate) / (1 * 24 * 60 * 60 * 1000);
    },
    // 库存数据拉取
    checkMoreStorge () {
      this.$router.push({ path: '/stockList/' });
      sessionStorage.setItem('fromWelcome', 1);
    },
    checkMoreStorgeData () {
      const params = {
        SERVICE_ID: '10177',
        OTYPE: 12,
        GYS_ID: Number(sessionStorage.getItem('tcId')),
        PAGEINDEX: 0,
        PAGESIZE: 10,
        SHOW: 0,
        WAREHOUSE_MODE: '1',
        FLAG: 0,
      };
      http.post(params).then((result) => {
        if (result[0]) {
          this.StorgeDataArry = result[0].OP_ROLE;
        }
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
      });
    },
    // 供应商资质
    checkSupplier () {
      this.$router.push({ path: '/supplierManage/' });
    },
    getSupplierQualification () {
      const params = {
        SERVICE_ID: '10002',
        OTYPE: 24,
        GYS_ID: Number(sessionStorage.getItem('tcId')),
      };
      http.post(params).then((result) => {
        this.checkSupplierArry = result;
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
      });
    },
  },
};
</script>
<style scoped>
.layout-content-main {
  margin-top: 50px;
  padding: 10px;
  background: #f5f7f9;
}

.content {
  margin: 0;
}

.left {
  width: 60%;
  height: 366px;
}

.right {
  width: 40%;
  height: 366px;
  margin-left: 20px;
  margin-right: -20px;
}

.left .left_top {
  width: 100%;
  height: 151px;
  background-color: #fff;
  border-radius: 8px;
}

.left .left_bottom {
  width: 100%;
  height: 195px;
  margin-top: 20px;
  background-color: #fff;
  border-radius: 8px;
}

.top_contant {
  display: flex;
  height: 120px;
  width: auto;
}

.top_contant .image {
  width: 70px;
  height: 70px;
  border-radius: 50%;
  background-color: #3399ff;
  margin-top: 20px;
}

.top_contant .top_foot {
  margin-left: 10px;
  margin-top: 40px;
  text-align: left;
  font-size: 14px;
}

.footer {
  display: flex;
  justify-content: space-between;
}

.top_contant_two {
  display: flex;
  height: 100px;
  background-color: #ffccff;
  padding: 0 10px;
  border-top-left-radius: 8px;
  border-top-right-radius: 8px;
}

.top_contant_two .image {
  width: 80px;
  height: 80px;
  margin-top: 10px;
}

.top_contant_two .top_foot {
  margin-left: 10px;
  margin-top: 12px;
  text-align: left;
  font-size: 14px;
  line-height: 24px;
  color: #fff;
}

.two_contant {
  width: 32%;
  height: 160px;
}

.two_bottom {
  display: flex;
  justify-content: space-between;
  font-size: 14px;
  padding: 0 10px;
  height: 30px;
  background-color: red;
  line-height: 30px;
  border-bottom-left-radius: 8px;
  border-bottom-right-radius: 8px;
}

.right .right_top {
  width: 100%;
  height: 366px;
  background-color: #fff;
  border-radius: 8px;
}

.left_left {
  width: 49%;
  background-color: #fff;
  border-radius: 8px;
}

.left_right {
  width: 49%;
  margin-left: 2%;
  background-color: #fff;
  border-radius: 8px;
}

.customer-table th {
  border: none;
}

.el-table td,
.el-table th.is-leaf {
  border-bottom: 0px solid #ebeef5;
}

.upload {
  width: 64%;
  height: 50px;
  display: flex;
  padding: 0 18% 0 18%;
}

.uploadFooter {
  padding: 0 15%;
  width: 70%;
  height: 30px;
  margin-top: 8px;
  display: flex;
  justify-content: space-between;
}
</style>



// WEBPACK FOOTER //
// src/components/base/welcome.vue